(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/play/leia/game-launcher.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/play/leia/game-launcher.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  Payfooter
} = svs.tur.ReactPayfooter;
const {
  GameLauncherLeia,
  GameWrapper,
  TopBar,
  Receipt,
  LoaderTicket,
  TicketIdPopper
} = svs.ticketgames.ticketUtility.components;
const {
  resizeFromFullscreen,
  resizeFromTicketInfo,
  defaultEventsLeiaFactory,
  tracking
} = svs.ticketgames.ticketUtility.utils;
const {
  ticketEvents: {
    GAME_LOADING,
    HAS_CLAIMED,
    HAS_BET,
    TAG
  },
  customNotifiers
} = svs.eInstant.lobby.play.leia;
const {
  gameEngineCode
} = svs.ticketgames.ticketUtility.utils.constants.leia;
const {
  useEffect,
  useContext,
  useState,
  useCallback,
  useReducer,
  useMemo
} = React;
const {
  matchPath
} = svs.app.ReactRouter;
const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_GAME_REF':
      return _objectSpread(_objectSpread({}, state), {}, {
        gameRef: action.payload
      });
    case 'SET_BET_ID':
      return _objectSpread(_objectSpread({}, state), {}, {
        betId: action.payload
      });
    default:
      return state;
  }
};
const getCloseUrl = () => {
  var _svs$utils$paramHandl;
  const {
    ALL_GAMES_INFO,
    ALL_GAMES,
    CATEGORY,
    CATEGORY_INFO,
    INFO,
    LOBBY
  } = svs.eInstant.constants.ROUTES;
  const returnUrlParam = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
    key: 'returnUrl'
  })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
  const returnUrl = returnUrlParam && decodeURIComponent(returnUrlParam);
  if (!returnUrl) return {
    url: LOBBY,
    match: null
  };
  let match;
  for (const route of [ALL_GAMES_INFO, ALL_GAMES, CATEGORY, CATEGORY_INFO, INFO]) {
    const path = "".concat(svs.core.data.baseUrl).concat(route);
    match = matchPath(returnUrl, {
      path,
      exact: true
    });
    if (match) break;
  }
  return {
    url: match ? returnUrl.replace(svs.core.data.baseUrl, '') : svs.eInstant.constants.ROUTES.LOBBY,
    match
  };
};
const GameLauncher = () => {
  var _wager$properties;
  const {
    useHistory
  } = ReactRouterDOM;
  const history = useHistory();
  const [fullScreenMargin, setFullScreenMargin] = useState(false);
  const [wrapperSize, setWrapperSize] = useState({});
  const {
    actions: {
      UPDATE_CATEGORIES
    },
    RouterContext
  } = svs.eInstant.store;
  const {
    wager,
    isDemo,
    ticketInfo
  } = useContext(svs.eInstant.lobby.play.PlayContext);
  const {
    dispatch: routerDispatch,
    state: {
      categories
    }
  } = useContext(RouterContext) || {
    dispatch: () => {},
    state: {
      categories: []
    }
  };
  const {
    GAME_URL
  } = svs.eInstant.store.actions;
  const {
    useCustomEvents
  } = svs.eInstant.lobby.play.leia;
  const {
    hideFooter,
    showFooter
  } = svs.eInstant.lobby.play.utils;
  const wagerId = wager === null || wager === void 0 || (_wager$properties = wager.properties) === null || _wager$properties === void 0 ? void 0 : _wager$properties.externalWagerId;
  const isFullScreenGame = ticketInfo.width === 0 && ticketInfo.height === 0;
  const onResizeFunc = isFullScreenGame ? resizeFromFullscreen : resizeFromTicketInfo;
  const gameAvailable = Boolean(wager) || ticketInfo.open;
  const betId = [gameEngineCode.VEIKKAUS, gameEngineCode.NEO].includes(ticketInfo.gameEngineCode) ? wagerId === null || wagerId === void 0 ? void 0 : wagerId.replace('/LEA', '') : parseInt(wagerId, 10);
  const [state, dispatch] = useReducer(reducer, {
    isDemo,
    ticketInfo,
    wager,
    betId,
    isEInstant: true,
    isFullScreenGame
  });
  const contextValue = useMemo(() => _objectSpread(_objectSpread({}, state), {}, {
    dispatch
  }), [state, dispatch]);
  const onClose = function () {
    var _match$params;
    let {
      name
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let {
      isCompleted = false,
      winAmount,
      anchorId
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!isCompleted) {
      tracking.trackTopBarActionQualtrics(name, winAmount);
    }
    const {
      url,
      match
    } = getCloseUrl();
    (match === null || match === void 0 || (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.gameId) && routerDispatch({
      type: GAME_URL,
      payload: {
        gameUrl: match.params.gameId
      }
    });
    history === null || history === void 0 || history.push(anchorId ? "".concat(url, "#").concat(anchorId) : url);
  };
  const updateCategories = () => {
    const newCategories = categories === null || categories === void 0 ? void 0 : categories.reduce((list, category) => {
      var _category$gameList;
      let c = category;
      if ((_category$gameList = category.gameList) !== null && _category$gameList !== void 0 && (_category$gameList = _category$gameList.config) !== null && _category$gameList !== void 0 && _category$gameList.lastPlayedTickets) {
        const newGames = [...category.games].filter(_ref => {
          let {
            type
          } = _ref;
          return type !== ticketInfo.type;
        });
        c = _objectSpread(_objectSpread({}, category), {}, {
          games: [ticketInfo, ...newGames]
        });
      }
      list.push(c);
      return list;
    }, []);
    routerDispatch({
      type: UPDATE_CATEGORIES,
      payload: {
        categories: newCategories
      }
    });
  };
  const onPlay = () => {
    history.push(ticketInfo.playUrl);
  };
  const {
    handleGameLoaded,
    handleOngoingGame,
    handleHasClaimed,
    isLoading,
    getLastWonAmount,
    shouldShowPlayAgain,
    handleHasBet
  } = useCustomEvents({
    ticketInfo,
    wager,
    isDemo,
    onClose,
    onPlay,
    dispatch,
    updateCategories
  });
  const {
    soundStatus,
    notifySoundStatus,
    soundEvents
  } = svs.ticketgames.ticketUtility.utils.useLeiaSoundStatus({
    ticketInfo
  });
  const shouldShowReceipt = !isLoading && (wager === null || wager === void 0 ? void 0 : wager.completed);
  useEffect(() => {
    const defaultEventsLeia = defaultEventsLeiaFactory({
      ticketInfo,
      isDemo,
      isEInstant: true,
      isReplay: wager === null || wager === void 0 ? void 0 : wager.completed,
      onClose: () => {
        var _match$params2;
        const {
          url,
          match
        } = getCloseUrl(routerDispatch);
        if (match !== null && match !== void 0 && (_match$params2 = match.params) !== null && _match$params2 !== void 0 && _match$params2.gameId) {
          routerDispatch({
            type: GAME_URL,
            payload: {
              gameUrl: match.params.gameId
            }
          });
        }
        history === null || history === void 0 || history.push(url);
      }
    });
    const customEvents = [{
      eventName: GAME_LOADING,
      handler: handleGameLoaded
    }, {
      eventName: TAG,
      handler: handleOngoingGame
    }, {
      eventName: HAS_CLAIMED,
      handler: handleHasClaimed
    }, {
      eventName: HAS_BET,
      handler: handleHasBet
    }];

    const {
      initialize,
      destroy
    } = svs.eInstant.lobby.play.leia.eventHandler(ticketInfo.gameLoader, [...defaultEventsLeia, ...customEvents, ...soundEvents]);
    initialize();
    if (!gameAvailable) {
      svs.ticketgames.ticketUtility.utils.showGameClosedDialog({
        isDemo,
        onClose,
        gameCode: ticketInfo.type || ticketInfo.name
      });
    }
    hideFooter();
    return () => {
      svs.eInstant.lobby.play.utils.removeBreakPointListeners();
      destroy();
      showFooter();
    };
  }, []);
  const onResize = useCallback(container => {
    const size = onResizeFunc(container, ticketInfo);
    if (isFullScreenGame) {
      setFullScreenMargin(size === null || size === void 0 ? void 0 : size.isMinHeight);
    } else {
      setWrapperSize(size);
    }
  }, []);
  const handleSoundClick = useCallback(soundStatus => {
    const loaderType = ticketInfo.gameLoader.toUpperCase();
    const setSoundStatus = customNotifiers.soundStatus[loaderType] || notifySoundStatus;
    setSoundStatus(soundStatus);
  }, [notifySoundStatus, ticketInfo]);
  const wrapperStyles = isFullScreenGame && fullScreenMargin ? {
    padding: '24px'
  } : _objectSpread(_objectSpread({}, wrapperSize), {}, {
    margin: 'auto'
  });
  return gameAvailable ? React.createElement("div", {
    className: "".concat(!isFullScreenGame ? 'padding-v-2' : ''),
    id: "einstant-game-launcher"
  }, React.createElement(GameWrapper, {
    context: contextValue,
    styles: wrapperStyles
  }, React.createElement(TopBar, {
    isSoundOn: soundStatus,
    onClose: () => {
      svs.ticketgames.ticketUtility.utils.showDialog({
        type: 'close',
        isDemo,
        onClose: () => {
          onClose(ticketInfo, {
            isCompleted: wager === null || wager === void 0 ? void 0 : wager.completed,
            isDemo,
            winAmount: getLastWonAmount()
          });
        }
      });
    },
    onSoundClick: () => {
      handleSoundClick(!soundStatus);
    },
    trackingLabel: tracking.createTopBarTrackingLabel({
      isDemo,
      location: wager ? 'mina-spel' : 'spela',
      gameCode: ticketInfo.type
    })
  }), React.createElement(GameLauncherLeia, {
    className: "relative",
    onResize: onResize
  }, !isLoading && React.createElement(TicketIdPopper, null), isLoading && React.createElement(LoaderTicket, null))), shouldShowReceipt && React.createElement(Receipt, {
    fetchedGame: wager,
    style: {
      opacity: 0
    },
    ticketInfo: ticketInfo
  }), shouldShowPlayAgain && React.createElement(Payfooter, {
    buttons: [{
      primary: true,
      text: 'Spela igen',
      onClick: onPlay
    }],
    isFixed: true
  })) : React.createElement("div", null);
};
setGlobal('svs.eInstant.lobby.play.leia.GameLauncher', GameLauncher);

 })(window);